export const wordsToArray = (raw) => {
  const ret = raw.split(/[\s,]+/g).filter((i) => i.length > 0);

  return ret;
};

export default wordsToArray;



// WEBPACK FOOTER //
// ./src/common/utils/wordsToArray.js